/** * ステータスカードコンポーネント */
<template>
  <div class="card-status">
    <!-- ユーザー -->
    <card-user
      can-user-name-click
      v-bind:user-id="userId"
      v-bind:user-name="userName"
      v-bind:profile-image-attach-file-type="profileImageAttachFileType"
      v-bind:update-date="updateDate"
      v-bind:groups="groups"
      v-on:usercard-username-click="
        $store.dispatch('updateProfileUserId', $event)
      "
    />
    <b-card-text
      align="left"
      v-on:click="$_onClickCard"
      class="event-card-body"
    >
      <div class="event-card-body-left">
        <!-- ステイタスタイトル -->
        <div class="event-card-title">
          <icon-status class="icon-status" v-bind:style="iconColors" />
          <p class="status-name" v-on:click="$_onClickTitle">
            {{ statusName }}
          </p>
        </div>
        <div class="update-at-text">{{ statusUpdateAt }}</div>
        <!-- ステイタスコメント -->
        <p class="event-card-description">
          {{ comment }}
        </p>
      </div>
      <!-- <div class="event-card-body-right"></div> -->
    </b-card-text>
  </div>
</template>

<script>
import CardUser from '@/components/AppCardUser.vue'
import ColorUtil from '@/js/util/ColorUtil.js'
import IconStatus from '@/assets/ifield/ic_status.svg?component'
import { useDateDisplayText } from '@/composables/UseDateDisplayText'
import { toRefs } from 'vue'

// タイムラインタイプ
const TIMELINE_TYPE = 2

export default {
  name: 'AppCardStatus',
  components: {
    'card-user': CardUser,
    'icon-status': IconStatus,
  },
  props: {
    // タイムラインID、ステイタスID(一意となるIDを設定する)
    id: {
      type: Number,
      required: true,
    },
    // ユーザID
    userId: {
      type: Number,
      required: true,
    },
    // ステイタス更新日時
    updateAt: {
      type: String,
      required: true,
    },
    // ステイタス名
    statusName: {
      type: String,
      required: true,
    },
    // ステイタスカラー
    statusTypeColor: {
      type: String,
      default: '#666666',
    },
    // コメント
    comment: {
      type: String,
      default: null,
    },
    // 送信者プロフィール画像の添付ファイルタイプ
    profileImageAttachFileType: {
      type: String,
      default: '9',
    },
    // 送信ユーザ名
    userName: {
      type: String,
      required: true,
    },
    /**
     * 基準日時
     */
    baseDate: {
      type: Date,
      default: null,
    },
    /**
     * 所属グループ
     */
    groups: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    // ステイタス更新日時の表示テキスト
    const { updateAt, baseDate } = toRefs(props)
    const { text } = useDateDisplayText({ date: updateAt, baseDate })
    return { statusUpdateAt: text }
  },
  data: function () {
    return {}
  },
  computed: {
    /**
     * ステイタス更新日時
     * @type {Date}
     */
    updateDate: function () {
      return this.updateAt ? new Date(this.updateAt) : null
    },
    // アイコンの色スタイル
    iconColors: function () {
      return {
        'background-color': this.statusTypeColor,
        'fill': ColorUtil.chooseTextColor(this.statusTypeColor),
      }
    },
  },
  created: function () {},
  updated: function () {},
  mounted: function () {},
  methods: {
    /**
     * クリック時のイベント
     */
    $_onClickCard: function () {
      this.$emit('statuscard-click', TIMELINE_TYPE, this.id)
    },
    /**
     * タイトルクリック時のイベント
     */
    $_onClickTitle: function (event) {
      event.stopPropagation()
      this.$emit('statuscard-title-click', TIMELINE_TYPE, this.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-checkin {
  height: 210px;
}

::v-deep .card-user {
  padding-right: 8px;
}

.event-card-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  padding: 0;
  margin: 10px 0 0 0;
  background-color: #f6f6f6;
  border-radius: 2px;
  overflow: hidden;
  transition: 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
}

.event-card-body-left {
  width: 100%;
  height: 160px;
  padding: 24px 10px 0 20px;
  .update-at-text {
    font-size: $font-size-small;
    color: #959595;
    margin: 8px 0 16px 0;
  }

  .event-card-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .status-name {
      color: $text-color-link;
      font-weight: bold;
      margin-right: 4px;
      font-size: 0.9em !important;
      margin-bottom: 0;
      line-height: 20px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.event-card-description {
  margin-bottom: 15px;
  color: #4d4d4d;
  font-size: 0.8em;
  line-height: 1.4;
  text-align: left;

  @supports (-webkit-line-clamp: 3) {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}

.icon-status {
  height: 20px;
  width: 20px;
  padding: 3px;
  margin-right: 12px;
  border-radius: 50%;
  position: relative;
  flex-shrink: 0;
}
</style>
